import React from "react";
import CabinWoodsLogo from "../../Assets/CabinWoods/Logo.png";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const handleClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  return (
    <footer>
      <img src={CabinWoodsLogo} alt="Cabin Woods Logo" />
      <ul className="footer-links">
        <li>
          <Link to="/galerija" onClick={() => handleClick("/")}>
            Galerija
          </Link>
        </li>
        <li>
          <Link to="/rezervacija" onClick={() => handleClick("/")}>
            Rezervacija
          </Link>
        </li>
        <li>
          <Link to="/politika-privatnosti" onClick={() => handleClick("/")}>
            Politika privatnosti
          </Link>
        </li>
        <li>
          <Link to="/uvjeti-korištenja" onClick={() => handleClick("/")}>
            Uvjeti korištenja
          </Link>
        </li>
        <li>
          <i className="fi fi-rs-at"></i>

          <a href="/"> cabinwoods@gmail.com</a>
        </li>
        <li>
          {" "}
          <i className="fi fi-rs-phone-flip"></i>
          <a href="/"> 095 123 4567</a>
          <h4>(Ivan)</h4>
        </li>
        <li>
          <i className="fi fi-rs-phone-flip"></i>

          <a href="/"> 095 000 1234</a>
          <h4>(Klara)</h4>
        </li>
      </ul>

      <div className="footer-social">
        <a href="/">
          <i className="fi fi-brands-facebook"></i>
        </a>
        <a href="/">
          <i className="fi fi-brands-instagram"></i>
        </a>
        <a href="/">
          <i className="fi fi-brands-tik-tok"></i>
        </a>
        <a href="/">
          <i className="fi fi-brands-twitter-alt-circle"></i>
        </a>
      </div>

      <div className="footer-rights">
        &copy; 2025 Cabin Woods. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
